import { render, staticRenderFns } from "./VerificationCodeInput.vue?vue&type=template&id=6a18e412&scoped=true"
import script from "./VerificationCodeInput.vue?vue&type=script&lang=ts"
export * from "./VerificationCodeInput.vue?vue&type=script&lang=ts"
import style0 from "./VerificationCodeInput.vue?vue&type=style&index=0&id=6a18e412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a18e412",
  null
  
)

export default component.exports